import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FileuploadService} from '../../../service/http/fileupload.service';

@Component({
  selector: 'app-delete-disclaimer-template',
  templateUrl: './delete-disclaimer-template.component.html',
  styleUrls: ['./delete-disclaimer-template.component.css']
})
export class DeleteDisclaimerTemplateComponent implements OnInit {

  disclaimerTemplateList: string[];
  disclaimerTemplateLoadName: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DeleteDisclaimerTemplateComponent>,
              private uploadService: FileuploadService) { }

  ngOnInit() {
    this.disclaimerTemplateList = this.data.disclaimerTemplateList;
  }

  deleteDisclaimerTemplate() {
    if(this.disclaimerTemplateLoadName !== undefined) {
      this.uploadService.deleteDisclaimerTemplate(this.disclaimerTemplateLoadName).subscribe();
      this.dialogRef.close();
    }
  }

}
